import React, { useContext, useEffect, useState } from "react";
import "./Deposit.css";
import Section_Header_Bar from "../../common_components/section_header_bar/Section_Header_Bar";
import { Form } from "react-bootstrap";
import Orange_White_Border_Btn from "../../common_components/common_btn/orange_white_border_btn/Orange_White_Border_Btn";
import Inner_Footer_Text_Component from "../../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import Successfull_Modal from "../../common_components/common_modal/successfull_modal/Successfull_Modal";
import Deposit_Lottie from "../../animation/deposit_lottie/Deposit_Lottie";
import { ApSetup } from "../../../utils/apis/master/Master";
import { postDepositMoney } from "../../../utils/apis/deposit/deposit";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../utils/context";
import { QRCodeSVG } from "qrcode.react";

const Deposit = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [appSetup, setAppSetup] = useState({});
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  const getAppSetup = async () => {
    const res = await ApSetup();
    if (res?.success) {
      setAppSetup(res.data);
    }
  };

  useEffect(() => {
    getAppSetup();
  }, []);

  const { userdata, getuserData, signin, IMG_URL } = useContext(Context);
  const [preview, setPreview] = useState(null);
  const handleImageChange = (e) => {
    const file = e.target.files?.[0];

    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  };

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("image", data.image[0]);
    formData.append("amount", data.amount);

    try {
      const res = await postDepositMoney(formData);

      if (res?.success) {
        setShowModal(true);
        getuserData(userdata?.id);
        setTimeout(() => {
          navigate("/my-account");
          setShowModal(false);
        }, 3000);
      } else {
        setError("amount", { message: res?.message || "Deposit failed" });
      }
    } catch (error) {
      console.error("API Error:", error);
      setError("amount", { message: "An error occurred. Please try again." });
    }
  };

  return (
    <section className="Deposit">
      <div className="header_div">
        <Section_Header_Bar />
      </div>

      <p className="section_title">Deposit</p>

      <div className="inner_section_box">
        <div className="row">
          <div className="col-md-6 order-md-1 order-2">
            <div className="inner_container">
              <div className="inner_box">
                <p className="section_title">Deposit Amount to your wallet</p>

                <Form onSubmit={handleSubmit(onSubmit)}>
                  <div className="outer_form_div">
                    <Form.Group className="custom_form_group">
                      <Form.Label className="black_input_label">
                        Deposit Amount
                      </Form.Label>
                      <Form.Control
                        className="blue_input"
                        type="number"
                        placeholder="Enter deposit amount"
                        {...register("amount", {
                          required: "Deposit amount is required",
                          min: {
                            value: appSetup?.min_fund_deposit || 1,
                            message: `Minimum deposit amount is $${appSetup?.min_fund_deposit}`,
                          },
                        })}
                      />
                    </Form.Group>

                    {errors.amount && (
                      <p className="text-danger mt-2">
                        {errors.amount.message}
                      </p>
                    )}
                  </div>

                  <div className="outer_form_div">
                    <Form.Group className="custom_form_group">
                      <Form.Label className="black_input_label">
                        Image
                      </Form.Label>

                      <Form.Control
                        className="blue_input"
                        type="file"
                        accept="image/*"
                        {...register("image", {
                          required: "Image is required",
                        })}
                        onChange={handleImageChange}
                      />
                    </Form.Group>

                    {errors?.image && (
                      <p className="text-danger mt-2">
                        {errors?.image?.message}
                      </p>
                    )}

                    {preview && (
                      <div className="mt-3">
                        <img
                          src={preview}
                          alt="Preview"
                          style={{
                            width: "150px",
                            height: "150px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            border: "1px solid #ddd",
                          }}
                        />
                      </div>
                    )}
                  </div>

                  <div className="minimum_diposite_div">
                    <p className="text">
                      The deposit amount is {appSetup?.min_fund_deposit}$. A
                      deposit fees of {appSetup?.deposit_percent ?? 0}% will be
                      deducted.
                    </p>

                    {signin == true ? (
                      <div className="orange_btn_div">
                        <Orange_White_Border_Btn
                          btn_name="Deposit"
                          type="submit"
                          onClick={handleSubmit(onSubmit)}
                        />
                      </div>
                    ) : (
                      <div className="orange_btn_div">
                        <Orange_White_Border_Btn
                          btn_name="Deposit"
                          onClick={navigate("/login")}
                        />
                      </div>
                    )}
                  </div>
                </Form>
              </div>
            </div>
          </div>

          <div className="col-md-6 order-md-2 order-1">
            <div className="inner_container">
              <div className="inner_box text-center">
                <div className="upi_qr_section">
                  <h4 className="section_title">Scan to Pay via UPI</h4>

                  <div>
                    <img
                      src={IMG_URL + appSetup?.qr_image}
                      alt="QR Code"
                      style={{
                        width: "200px",
                        height: "200px",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  {/* {appSetup?.upi_id ? (
                    <>
                      <QRCodeSVG
                        value={`upi://pay?pa=${appSetup?.upi_id}&pn=MerchantName`}
                        size={200}
                        level="H"
                        includeMargin={true}
                      />
                      <p className="upid">{appSetup?.upi_id}</p>
                    </>
                  ) : (
                    <p>No UPI ID available</p>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer_text">
          <Inner_Footer_Text_Component />
        </div>
      </div>

      <Successfull_Modal
        message="Deposit Request Sent Successfully!"
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        lottie={<Deposit_Lottie />}
      />
    </section>
  );
};

export default Deposit;
